module.exports = __webpack_public_path__ + "static/media/company-setup.0cbf467e.svg";